import React from 'react';
import { Row, Col, Alert, Button } from 'react-bootstrap';

import OrderAppCheckListContainer from '../containers/OrderAppCheckListContainer';
import FieldGroup from './common/FieldGroup.jsx';

import { fittingappHost } from '../config';

export default class Fitting1AppCheckComponent extends React.Component {

  componentDidMount() {
  }

  render() {

    let editDiv = null;
    let btn = [];
    if (this.props.showAppCheckDiv === 'edit') {
      btn = (
        <Button onClick={this.props.editAppCheck} bsStyle="info">
          修改
        </Button>
      )
    } else if (this.props.showAppCheckDiv === 'add') {
      btn = (
        <Button onClick={this.props.addAppCheck} bsStyle="info">
          新增
        </Button>
      )
    }

    let fittingappUrl = "";
    if (this.props.orderAppCheck.get('checkId')) {
      fittingappUrl = fittingappHost + "fitting?order_id="
        + this.props.orderAppCheck.get('orderId') + "&check_id="
        + this.props.orderAppCheck.get('checkId');
    }

    if ((this.props.showAppCheckDiv === 'edit' || this.props.showAppCheckDiv === 'add')
      && this.props.orderAppCheck) {
      editDiv = (
        <div className='box' style={{ padding: 20 }}>
          <Row>
            <Col xs={2} sm={2} md={2}>
              {btn}
            </Col>
            <Col xs={10} sm={10} md={10}>
              <Alert bsStyle={this.props.alertStyle}>
                {this.props.alertMessage}
              </Alert>
            </Col>
          </Row>
          <Row>
            <Col xs={6} sm={6} md={6}>
              <label className="control-label" style={{ marginBottom: 20 }}>檢查碼: {this.props.orderAppCheck.get('checkId')}</label>
            </Col>
            <Col xs={6} sm={6} md={6}>
              <label className="control-label" style={{ marginBottom: 20 }}>訂單編號: {this.props.orderAppCheck.get('orderId')}</label>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4}>
              <FieldGroup
                id="fittingName"
                type="text"
                label="套量訂單顯示"
                value={this.props.orderAppCheck.get('fittingName')}
                placeholder=""
                required="true"
                onChange={(id, value) => {
                  this.props.setValue(id, value);
                }}
                validation={this.props.orderAppCheckValidation.get('fittingName')}
              />
            </Col>
            <Col xs={4} sm={4} md={4}>
              <FieldGroup
                id="startDate"
                type="date"
                label="開始時間"
                value={this.props.orderAppCheck.get('startDate')}
                placeholder=""
                required="true"
                onChange={(id, value) => {
                  this.props.setValue(id, value);
                }}
                validation={this.props.orderAppCheckValidation.get('startDate')}
              />
            </Col>
            <Col xs={4} sm={4} md={4}>
              <FieldGroup
                id="endDate"
                type="date"
                label="結束時間"
                value={this.props.orderAppCheck.get('endDate')}
                placeholder=""
                required="true"
                onChange={(id, value) => {
                  this.props.setValue(id, value);
                }}
                validation={this.props.orderAppCheckValidation.get('endDate')}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={12}>
              <label className="control-label" style={{ marginBottom: 20 }}>消防員套量URL:&nbsp;&nbsp;{fittingappUrl}</label>
            </Col>
            <Col xs={12} sm={12} md={12}>
              可至 QR Code 產生器: <a href="https://qrcode-generator.tw/" target="_blank">https://qrcode-generator.tw/</a>，輸入「消防員套量URL」產生 QR code
            </Col>
          </Row>
        </div>
      )
    }

    return (
      <div>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={12} md={12}>
            <Button onClick={this.props.showOrderAddAppCheck} style={{ marginBottom: 20 }}>
              新增
            </Button>
          </Col>
          <Col xs={12} sm={12} md={12}>
            <OrderAppCheckListContainer />
          </Col>
        </Row>
        {editDiv}
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/Fitting1AppCheckComponent.jsx